import { render, staticRenderFns } from "./personalInfoView.vue?vue&type=template&id=50090e26&"
import script from "./personalInfoView.vue?vue&type=script&lang=js&"
export * from "./personalInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports